import React from 'react';
import clsx from 'clsx';
import { Material3Card } from '../ui/Material3Card';
import Breadcrumbs, { type SeoBreadcrumb } from '../seo/Breadcrumbs';

interface PrimaryFrameProps {
  eyebrow?: string;
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  breadcrumbs?: SeoBreadcrumb[];
  children: React.ReactNode;
  className?: string;
  shellClassName?: string;
  bodyClassName?: string;
  headerClassName?: string;
}

const PrimaryFrame: React.FC<PrimaryFrameProps> = ({
  eyebrow,
  title,
  subtitle,
  actions,
  breadcrumbs,
  children,
  className,
  shellClassName,
  bodyClassName,
  headerClassName,
}) => {
  const hasHeader = eyebrow || title || subtitle || actions;

  return (
    <section className={clsx('brand-primary-shell', shellClassName)}>
      <Material3Card variant="elevated" className={clsx('brand-primary-frame', className)}>
        <div className={clsx('brand-primary-body', bodyClassName)}>
          {hasHeader ? (
            <div className={clsx('brand-primary-header', headerClassName)}>
              <div className="space-y-2">
                {breadcrumbs ? <Breadcrumbs items={breadcrumbs} /> : null}
                {eyebrow ? <div className="brand-kicker">{eyebrow}</div> : null}
                {title ? <h1 className="brand-title max-w-3xl">{title}</h1> : null}
                {subtitle ? <p className="brand-copy-sm max-w-2xl">{subtitle}</p> : null}
              </div>
              {actions ? <div className="flex flex-wrap gap-2">{actions}</div> : null}
            </div>
          ) : null}
          {children}
        </div>
      </Material3Card>
    </section>
  );
};

export default PrimaryFrame;
